import styled from 'styled-components';

// Heading 1 - Main page titles
export const H1 = styled.h1`
  font-family: 'Inter', sans-serif;
  font-size: 48px;
  font-weight: 700;
  line-height: 1.2;
  color: #1a1a1a;
  margin: 0;
  letter-spacing: -0.015em;

  @media (max-width: 768px) {
    font-size: 36px;
  }

  @media (max-width: 480px) {
    font-size: 28px;
  }
`;

// Heading 2 - Section titles
export const H2 = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 32px;
  font-weight: 600;
  line-height: 1.3;
  color: #1a1a1a;
  margin: 0;
  letter-spacing: -0.015em;

  @media (max-width: 768px) {
    font-size: 28px;
  }

  @media (max-width: 480px) {
    font-size: 24px;
  }
`;

// Heading 3 - Subsection titles
export const H3 = styled.h3`
  font-family: 'Inter', sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.4;
  color: #1a1a1a;
  margin: 0;
  letter-spacing: -0.015em;

  @media (max-width: 768px) {
    font-size: 20px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

// Heading 4 - Card titles
export const H4 = styled.h4`
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.4;
  color: #1a1a1a;
  margin: 0;
  letter-spacing: -0.015em;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

// Heading 5 - Small headings
export const H5 = styled.h5`
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
  color: #1a1a1a;
  margin: 0;
  letter-spacing: -0.015em;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

// Heading 6 - Labels
export const H6 = styled.h6`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  margin: 0;
  letter-spacing: -0.015em;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

// Paragraph - Body text
export const P = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.6;
  color: #4a4a4a;
  margin: 0;
  letter-spacing: -0.015em;

  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

// Large paragraph - Intro/lead text
export const PLarge = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.7;
  color: #4a4a4a;
  margin: 0;
  letter-spacing: -0.015em;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

// Small text - Captions, labels
export const PSmall = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  margin: 0;
  letter-spacing: -0.015em;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

// Label - Form labels, tags
export const Label = styled.label`
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  color: #333;
  margin: 0;
  display: block;
  letter-spacing: -0.015em;
`;

// Span - Inline text
export const Span = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  color: inherit;
  letter-spacing: -0.015em;
`;

// Strong - Bold emphasis
export const Strong = styled.strong`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  letter-spacing: -0.015em;
`;

// Em - Italic emphasis
export const Em = styled.em`
  font-family: 'Inter', sans-serif;
  font-style: italic;
  letter-spacing: -0.015em;
`;
